import Vue from 'vue'
import Vuex from 'vuex'

import {auth, db} from '../firebase'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usuario: null,
    admin: null,
    error: null,
    auditorias: [],
    noVerificadas: [],
    consumosEstimados: [],
    auditoria: {nombre: '', id: '', verificada: false,
      datos: {
        electricidad:{
          iluminacion: {
            nombre: "popupIluminacion",
            titulo: "Iluminación",
            icono: "Iluminacion.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          refrigeracion: {
            nombre: "popupRefrigeracion",
            titulo: "Refrigeración",
            icono: "Heladera.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
        },
          lineablanca: {
            nombre: "popupLineaBlanca",
            titulo: "Línea Blanca",
            icono: "LineaBlanca.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          cocina: {
            nombre: "popupCocina",
            titulo: "Cocina",
            icono: "Cocina.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          climatizacion: {
            nombre: "popupClimatizacion",
            titulo: "Climatización",
            icono: "Aire.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          electronica: {
            nombre: "popupElectronica",
            titulo: "Tecnología",
            icono: "Informatica.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          otros: {
            nombre: "popupOtros",
            titulo: "Otros",
            icono: "Secador.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
        },
          aguacaliente: {
            nombre: "popupNombre",
            titulo: "Agua caliente",
            icono: "AguaCaliente.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            tiempo: 0,
            dias: 0,
          }
        },
        gas: {
          consumosRegistrados: {
            nombre: "popupConsumosRegistrados",
            titulo: "Consumos Registrados",
            icono: "facturaGas.png",
            modal: false,
            grafico: false,
            cantidadHabitantes: 0,
            bimestre1:0,
            bimestre2:0,
            bimestre3:0,
            bimestre4:0,
            bimestre5:0,
            bimestre6:0,
            consumoAnual: 0,
            consumoBase: 0,
          },
          cocina: {
            nombre: "popupCoccion",
            titulo: "Cocción",
            icono: "Coccion.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
          },
          aguacaliente: {
            nombre: "popupACS",
            titulo: "Agua Caliente Sanitaria (ACS)",
            icono: "AguaCaliente.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            piloto: 0,
          },
          calefaccion: {
            nombre: "popupCalefaccion",
            titulo: "Calefacción",
            icono: "Estufa.png",
            modal: false,
            artefactos: [],
            cantidad: 0,
            consumo: 0,
            piloto: 0,
          }
        }
      }
    }
  },
  mutations: {
    setUsuario(state, payload){
      state.usuario = payload
    },
    setAdmin(state, payload){
      state.admin = payload
    },
    setError(state, payload){
      state.error = payload
    },
    setAuditorias(state, payload){
      state.auditorias = payload
    },
    setNoVerificadas(state, payload){
      state.noVerificadas = payload
    },
    setConsumosEstimadosHeladeras(state, payload){
      state.consumosEstimados = payload
    },
    setAuditoria(state, payload){
      state.auditoria = payload
    },
    setEliminarAuditoria(state, payload){
      state.auditorias = state.auditorias.filter(item => item.id !== payload)
    }
  },
  actions: {
    verificarAuditoria({commit, state}, item){
      db.collection('auditorias').doc(item).update({
        verificada: true
    })
    .then(() => {
      
      const noVerificadas = []
      db.collection('auditorias').where('verificada','==', false).get()
      .then(res => {
        res.forEach(doc => {
          let auditoria = doc.data()
          auditoria.id = doc.id
          noVerificadas.push(auditoria)
          })
        })
      .catch(error => {
        console.log(error)
      })
      commit('setNoVerificadas', noVerificadas)

      router.push({name: 'Admin'})
    })
    .catch(error => console.log(error))
    },
    eliminarAuditoria({commit, state}, id){
      //db.collection(state.usuario.email).doc(id).delete()
      db.collection('auditorias').doc(id).delete()
      .then(() => {
          commit('setEliminarAuditoria', id)
      })
      .catch(error => console.log(error))
    },
    agregarAuditoria({commit, state}, alta){
      //db.collection(state.usuario.email).add({
      //db.collection('users').doc(state.usuario.email).collection('auditorias').add({
        db.collection('auditorias').add({
          usuario: state.usuario.email,
          nombre: alta.nombreAuditoria,
          fecha: alta.fecha,
          tipo: alta.tipo,
          habitantes: alta.habitantes,
          ambientes: alta.ambientes,
          superficie: alta.superficie,
          direccion: alta.direccion,
          observaciones: alta.observaciones,
          localidad: alta.localidad,
          provincia: alta.provincia,
          codigoPostal: alta.codigoPostal,
          auditor: alta.auditor,
          email: alta.email,
          nota: alta.nota,
          modalDatosInmueble: alta.modalDatosInmueble,
          modalNotas: alta.modalNotas,
          verificada: false,
          datos: {
            electricidad:{
              iluminacion: {
                nombre: "popupIluminacion",
                titulo: "Iluminación",
                icono: "Iluminacion.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              refrigeracion: {
                nombre: "popupRefrigeracion",
                titulo: "Refrigeración",
                icono: "Heladera.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
            },
              lineablanca: {
                nombre: "popupLineaBlanca",
                titulo: "Línea Blanca",
                icono: "LineaBlanca.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              cocina: {
                nombre: "popupCocina",
                titulo: "Cocina",
                icono: "Cocina.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              climatizacion: {
                nombre: "popupClimatizacion",
                titulo: "Climatización",
                icono: "Aire.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              electronica: {
                nombre: "popupElectronica",
                titulo: "Tecnología",
                icono: "Informatica.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              otros: {
                nombre: "popupOtros",
                titulo: "Otros",
                icono: "Secador.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
            },
              aguacaliente: {
                nombre: "popupNombre",
                titulo: "Agua caliente",
                icono: "AguaCaliente.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                tiempo: 0,
                dias: 0,
              }
            },
            gas: {
              consumosRegistrados: {
                nombre: "popupConsumosRegistrados",
                titulo: "Consumos Registrados",
                icono: "facturaGas.png",
                modal: false,
                grafico: false,
                cantidadHabitantes: 0,
                bimestre1:0,
                bimestre2:0,
                bimestre3:0,
                bimestre4:0,
                bimestre5:0,
                bimestre6:0,
                consumoAnual: 0,
                consumoBase: 0,
              },
              cocina: {
                nombre: "popupCoccion",
                titulo: "Cocción",
                icono: "Coccion.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
              },
              aguacaliente: {
                nombre: "popupACS",
                titulo: "Agua Caliente Sanitaria (ACS)",
                icono: "AguaCaliente.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                piloto: 0,
              },
              calefaccion: {
                nombre: "popupCalefaccion",
                titulo: "Calefacción",
                icono: "Estufa.png",
                modal: false,
                artefactos: [],
                cantidad: 0,
                consumo: 0,
                piloto: 0,
              }
            }
          }
      })
      .then(doc => {
          router.push({name: 'Inicio'})
      })
      .catch(error => console.log(error))
    },
    getAuditoria({commit, state}, id){
      //db.collection(state.usuario.email).doc(id).get()
      //db.collection('fpvs').doc('usuarios').collection(state.usuario.email).doc(id).get()
      //db.collection('users').doc(state.usuario.email).collection('auditorias').doc(id).get()
      db.collection('auditorias').doc(id).get()
      .then(doc => {
          let auditoria = doc.data()
          auditoria.id = doc.id
          commit('setAuditoria', auditoria)
      })
      .catch(error => console.log(error))
    },
    editarAuditoria({commit, state}, auditoria){
      //db.collection(state.usuario.email).doc(auditoria.id).update({
      //db.collection('fpvs').doc('usuarios').collection(state.usuario.email).doc(auditoria.id).update({
      //db.collection('users').doc(state.usuario.email).collection('auditorias').doc(auditoria.id).update({
        db.collection('auditorias').doc(auditoria.id).update({
          nombre: auditoria.nombre,
          fecha: auditoria.fecha,
          tipo: auditoria.tipo,
          habitantes: auditoria.habitantes,
          ambientes: auditoria.ambientes,
          superficie: auditoria.superficie,
          direccion: auditoria.direccion,
          observaciones: auditoria.observaciones,
          localidad: auditoria.localidad,
          provincia: auditoria.provincia,
          codigoPostal: auditoria.codigoPostal,
          auditor: auditoria.auditor,
          email: auditoria.email,
          nota: auditoria.nota,
          datos: auditoria.datos
      })
      /* .then(() => {
          router.push({name: 'Editar'});
      }) */
      .catch(error => console.log(error))
    },
    getAuditorias({commit, state}){
      const Auditorias = []
      //db.collection(state.usuario.email).get()
      //db.collection('fpvs').doc('usuarios').collection(state.usuario.email).get()
      //db.collection('users').doc(state.usuario.email).collection('auditorias').get()
      db.collection('auditorias').where('usuario','==', state.usuario.email).get()
      .then(res => {
          res.forEach(doc => {
              //console.log(doc.id)
              //console.log(doc.data())
              let auditoria = doc.data()
              auditoria.id = doc.id
              Auditorias.push(auditoria)
          })
          commit('setAuditorias', Auditorias)
      })
    },
    getNoVerificadas({commit, state}){
      const noVerificadas = []
      //db.collection(state.usuario.email).get()
      //db.collection('fpvs').doc(state.usuario.email).collection('auditorias').get()
      db.collection('auditorias').where('verificada','==', false).get()
      .then(res => {
        res.forEach(doc => {
          //console.log(doc.id)
         // console.log(doc.data())
          let auditoria = doc.data()
          auditoria.id = doc.id
          noVerificadas.push(auditoria)
          })
        })
      .catch(error => {
        console.log(error)
      })
      commit('setNoVerificadas', noVerificadas)
    },
    getConsumosEstimadosHeladeras({commit, state}){
      const CONSUMOS_ESTIMADOS_HELADERAS = []
      //db.collection(state.usuario.email).get()
      //db.collection('fpvs').doc(state.usuario.email).collection('auditorias').get()
      db.collection('consumosEstimados').doc('heladeras').get()
      .then( (doc) => {
        if (doc) {
            let consumos = doc.data()
            CONSUMOS_ESTIMADOS_HELADERAS.push(consumos)
        }
      })
      .catch(error => {
        console.log(error)
      })
      commit('setConsumosEstimadosHeladeras', CONSUMOS_ESTIMADOS_HELADERAS)
    },
    crearUsuario({commit}, usuario){
      auth.createUserWithEmailAndPassword(usuario.email, usuario.password)
        .then(res => {
          //console.log(res)
          const usuarioCreado = {
            email: res.user.email,
            uid: res.user.uid
          }
            //db.collection('fpvs').doc('usuarios').collection(res.user.email).add({
            db.collection('users').doc(res.user.email).collection('configuracion').add({
            nombre: 'Configuración Inicial',
            admin: false
          }).then(doc => {
            commit('setUsuario', usuarioCreado)
            router.push('/')
          }).catch(error => console.log(error))

        })
        .catch(error => {
          console.log(error)
          commit('setError', error)
        })
    },
    ingresoUsuario({commit}, usuario){
      auth.signInWithEmailAndPassword(usuario.email, usuario.password)
        .then(res => {
          //console.log(res)
          const usuarioLogeado = {
            email: res.user.email,
            uid: res.user.uid
          }
          commit('setUsuario', usuarioLogeado)
          db.collection('users').doc(res.user.email).collection('configuracion').get()
          .then(res => {
            res.forEach(doc => {
               // console.log(doc.data())
                let userConfig = doc.data()
                if (userConfig.admin === true) {
                  this.state.admin = true
                } else {
                  this.state.admin = false
                }
            router.push('/')
            })
          })
        })
        .catch(error => {
          console.log(error)
          commit('setError', error)
        })
    },
    cerrarSesion({commit}){
      auth.signOut()
        .then(() => {
          this.state.admin = false
          router.push('/acceso')
        })
    },
    detectarUsuario({commit}, usuario){
      commit('setUsuario', usuario)
    }
  },
  getters:{
    existeUsuario(state){
      if(state.usuario === null){
        return false
      }else{
        return true
      }
    },
    usuarioAdmin(state){
      if(state.admin === null || state.admin === false) {
        return false
      }else{
        return true
      }
    }
  },
  modules: {
  }
})
